export default class ParseError extends Error {
  constructor(error) {
    const isErrorInstance = error instanceof Error
    super(isErrorInstance ? error.message : error?.toString())
    this.name = "ParseError"
    this.stack = isErrorInstance ? error.stack : ""
  }
}
